var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    fill: "#9AE0EA",
    className: "fill-dynamic-1",
    d: "M21,2c10.5,0,19,8.5,19,19s-8.5,19-19,19S2,31.5,2,21S10.5,2,21,2z M21,7C13.3,7,7,13.3,7,21 s6.3,14,14,14s14-6.3,14-14S28.7,7,21,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M21,40.5c-0.8,0-1.6,0-2.3-0.1l0.1-1c0.7,0.1,1.5,0.1,2.2,0.1c2.9,0,5.6-0.6,8.2-1.9l0.4,0.9 C26.9,39.8,24,40.5,21,40.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M12.8,38.7c-3.4-1.6-6.3-4.2-8.3-7.4l0.8-0.5c1.9,3.1,4.6,5.5,7.9,7L12.8,38.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M21,35.5c-3.5,0-6.9-1.3-9.5-3.5l0.7-0.8c2.5,2.1,5.6,3.3,8.8,3.3c0.3,0,0.6,0,1,0l0.1,1 C21.7,35.5,21.3,35.5,21,35.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M34.6,34.9l-0.7-0.7c2.6-2.5,4.4-5.7,5.1-9.2l1,0.2C39.2,28.9,37.4,32.3,34.6,34.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M28,33.7l-0.5-0.9c3.1-1.7,5.5-4.6,6.5-8l1,0.3C33.8,28.7,31.3,31.9,28,33.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M7.8,27c-0.9-1.9-1.3-3.9-1.3-6c0-1.7,0.3-3.5,0.9-5.1l0.9,0.3c-0.6,1.5-0.8,3.1-0.8,4.7c0,2,0.4,3.8,1.2,5.6 L7.8,27z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M2.1,25.6c-0.4-1.5-0.6-3.1-0.6-4.6c0-2.2,0.4-4.4,1.1-6.5l0.9,0.3c-0.7,2-1,4-1,6.1c0,1.5,0.2,3,0.5,4.4 L2.1,25.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M39.4,19.2c-0.3-3.6-1.7-7-4-9.8l0.8-0.6c2.4,3,3.8,6.5,4.2,10.3L39.4,19.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M34.4,19.1c-0.5-3.6-2.4-6.7-5.3-8.9l0.6-0.8c3.1,2.3,5.1,5.7,5.7,9.5L34.4,19.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M11.5,11.5l-0.7-0.7C13.5,8,17.1,6.5,21,6.5c1,0,2.1,0.1,3.1,0.3l-0.2,1C22.9,7.6,22,7.5,21,7.5 C17.4,7.5,14,8.9,11.5,11.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M6.3,9.7L5.5,9.1c2.3-3,5.4-5.3,9-6.5l0.3,0.9C11.5,4.7,8.5,6.9,6.3,9.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color-base",
    d: "M31.1,5.5c-3-2-6.5-3-10.1-3l-0.4,0l0-1l0.4,0c3.8,0,7.5,1.1,10.7,3.2L31.1,5.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    className: "fill-dynamic-2",
    fill: "#EEBAD4",
    d: "M21,11c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S15.5,11,21,11z M21,17.7 c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3S22.8,17.7,21,17.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.bc8d3f25699dc88a46722492ce31d7d7.svg";
export { ForwardRef as ReactComponent };